import theme from "css/theme/light"

export function issueReportStatusColor(status: number) {
  switch (status) {
    case 1:
      return "warning"
    case 2:
      return "primary"
    case 3:
      return "primary"
    case 4:
      return "primary"
    case 5:
      return "success"
    default:
      return undefined
  }
}

export function issueReportStatusAlertColor(status: number) {
  switch (status) {
    case 1:
      return (theme.palette as any).orange[900]
    case 2:
      return (theme.palette as any).primary[900]
    case 3:
      return (theme.palette as any).primary[900]
    case 4:
      return (theme.palette as any).primary[900]
    case 5:
      return (theme.palette as any).green[900]
    case 6:
      return (theme.palette as any).red[900]
    default:
      return undefined
  }
}

export function issueReportStatusAlertBackgroundColor(status: number) {
  switch (status) {
    case 1:
      return (theme.palette as any).orange[200]
    case 2:
      return (theme.palette as any).primary[300]
    case 3:
      return (theme.palette as any).primary[300]
    case 4:
      return (theme.palette as any).primary[300]
    case 5:
      return (theme.palette as any).green[200]
    case 6:
      return (theme.palette as any).red[200]
    default:
      return undefined
  }
}
